<template>
  <v-navigation-drawer
    v-model="drawerValue"
    absolute
    temporary
    dark
    color="#272b30"
  >
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          <v-img src="@/assets/logo.png" max-width="100"></v-img>
          <br />
        </v-list-item-title>
        <v-list-item-subtitle class="pt-2">
          <v-icon> mdi-account </v-icon>
          {{ userInfo.username }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider />

    <v-list v-if="visibleItems.length" dense class="py-0">
      <v-subheader v-if="!stockOnly"> Event Management</v-subheader>
      <v-list-item v-for="item in visibleItems" :key="item.title" link :to="item.to">
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <br />
    <v-divider />

    <v-list dense class="py-0" v-if="IsAdmin">
      <v-subheader> Admin Control</v-subheader>
      <v-list-item
        v-for="item in adminItems"
        :key="item.title"
        link
        :to="item.to"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <div class="d-flex align-center justify-end pr-4">
      <span style="color: #aaa; font-size: 12px">v{{ version }}</span>
    </div>
    <br />

    <!-- <v-divider /> -->
    <!-- <v-list dense class="py-0">
      <v-subheader> Stock Control </v-subheader>
      <v-list-item v-for="item in stockControlItems" :key="item.title" link :to="item.to">
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list> -->

    <br />

    <v-divider />
    <div class="pa-2">
      <utility-LogoutButton block outlined />
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import packageJson from "../../../package.json";
import { isStockOnlyAccess, hasStock } from "@/utils/permissions";

export default {
  data: () => ({
    version: packageJson.version,
    items: [
      {
        title: "Event Management",
        icon: "mdi-eventbrite",
        to: "EventManagement",
      },
      {
        title: "Product Management",
        icon: "mdi-shopping",
        to: "ProductManagement",
      },
    ],
    adminItems: [
      { title: "Dashboard Users", icon: "mdi-account", to: "DashboardUsers" },
      {
        title: "Dashboard Groups",
        icon: "mdi-account-group",
        to: "DashboardGroups",
      },
      { title: "TSG Admins", icon: "mdi-shield-account", to: "TsgAdmins" },
      { title: "Administration", icon: "mdi-sitemap", to: "Administration" },
    ],
    stockControlItems: [
      {
        title: "Product Stores & Stock Levels",
        icon: "mdi-speedometer",
        to: "ProductStoresStockLevels",
      },
      {
        title: "Source Products & Mappings",
        icon: "mdi-map",
        to: "SourceProductsMappings",
      },
    ],
  }),
  computed: {
    ...mapState("app", ["userInfo"]),
    ...mapState("filter", ["IsAdmin", "globalEventFilter", "userEventPermissions"]),
    stockOnly() {
      if (this.IsAdmin) return false;
      const eventId = this.globalEventFilter?.EventId;
      const acl = (this.userEventPermissions || []).find(
        (e) => e.EventId === eventId
      );
      if (acl) return isStockOnlyAccess(acl);
      return hasStock(this.globalEventFilter?.Permission);
    },
    visibleItems() {
      if (!this.stockOnly) return this.items;
      return [];
    },
    drawerValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      },
    },
  },
  methods: {
    ...mapMutations("app", ["setDrawer"]),
  },
};
</script>

<style>
.menulist {
  background-color: "#272b30";
}
</style>
